import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, WorkoutTemplate } from 'types';
import { client } from 'utils/api-client';

export default function useCreateWorkoutTemplateFromWorkout(): UseMutationResult<
  AxiosResponse<WorkoutTemplate>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const createWorkoutTemplate = (workoutId: string): Promise<AxiosResponse<WorkoutTemplate>> => {
    return client.post('workout-templates/from-workout/', { workoutId });
  };

  return useMutation(createWorkoutTemplate, {
    onSuccess: () => {
      queryClient.invalidateQueries('workoutTemplates');
    },
  });
}
